import { render, staticRenderFns } from "./BlockForm.vue?vue&type=template&id=0e04df36"
import script from "./BlockForm.vue?vue&type=script&lang=js"
export * from "./BlockForm.vue?vue&type=script&lang=js"
import style0 from "./BlockForm.vue?vue&type=style&index=0&id=0e04df36&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports